import { useTranslation } from '@rhino-project/core/i18n';
import { AuthForm, type AuthFormValues } from '../../components/auth/AuthForm';
import { useSignUpAction } from '@rhino-project/core/queries';
import { NetworkParamError } from '@rhino-project/core/lib';
import { hasOrganizationsModule } from '@rhino-project/core/utils';
import { AuthPage, type AuthPageProps } from './AuthPage';
import { useRhinoConfig } from '@rhino-project/core/config';
import { OmniAuthButtonGroup } from '../../components/buttons/OmniAuthButtonGroup';
import { Link } from '@tanstack/react-router';

export const SignUpPage = (props: AuthPageProps) => {
  const { t } = useTranslation();
  const { appName } = useRhinoConfig();
  const { mutate: signUpAction, isPending, error } = useSignUpAction();
  const paramError = error as NetworkParamError | null;

  const handleSubmit = (formValues: AuthFormValues) => signUpAction(formValues);

  const authDesc = t(
    'rhino.frontend.messages.enter_your_email_address_and_password_to_create_account'
  );

  return (
    <AuthPage
      title={t('rhino.frontend.messages.create_your_account')}
      description={authDesc}
      {...props}
    >
      <AuthForm
        emailField
        passwordField
        passwordConfirmField
        organizationField={hasOrganizationsModule()}
        primaryAction={t('rhino.frontend.messages.sign_up')}
        isPending={isPending}
        errors={paramError?.errors}
        onSubmit={handleSubmit}
        {...props}
      />
      <OmniAuthButtonGroup />
      <p className="text-sm text-muted text-center mt-4">
        {t('rhino.frontend.messages.already_have_account', { appName })}{' '}
        <Link className="text-accent hover:underline" to="/auth/signin">
          {t('rhino.frontend.messages.sign_in')}
        </Link>
      </p>
    </AuthPage>
  );
};
